export const TASK_NOTIFICATION = 'task';
export const TASK_NOTIFICATION_ID = 1;

export const PLAYBOOK_NOTIFICATION = 'playbook';
export const PLAYBOOK_NOTIFICATION_ID = 2;

export const EMAIL_NOTIFICATION = 'email';
export const EMAIL_NOTIFICATION_ID = 3;

export const ENTITY_NOTIFICATION = 'entity';
export const ENTITY_NOTIFICATION_ID = 4;

export const BULK_UPDATE_NOTIFICATION = 'bulkUpdate';
export const BULK_UPDATE_NOTIFICATION_ID = 6;

export const MENTIONS_NOTIFICATION = 'mentions';
export const MENTIONS_NOTIFICATION_ID = 7;

export const OTHER_NOTIFICATION = 'other';
export const OTHER_NOTIFICATION_ID = 8;

export const TICKET_NOTIFICATION = 'ticket';
export const TICKET_NOTIFICATION_ID = 9;

export const ALL_NOTIFICATIONS = 'all';

export const EVENT_TYPE_IDS = [
  TASK_NOTIFICATION_ID,
  PLAYBOOK_NOTIFICATION_ID,
  EMAIL_NOTIFICATION_ID,
  ENTITY_NOTIFICATION_ID,
  BULK_UPDATE_NOTIFICATION,
  MENTIONS_NOTIFICATION_ID,
  OTHER_NOTIFICATION_ID,
  TICKET_NOTIFICATION_ID,
];

export const NOTIFICATION_MODES = [1];

export const NOTIFICATION_CATEGORY_EVENT_TO_ID_MAP = {
  [TASK_NOTIFICATION]: TASK_NOTIFICATION_ID,
  [PLAYBOOK_NOTIFICATION]: PLAYBOOK_NOTIFICATION_ID,
  [EMAIL_NOTIFICATION]: EMAIL_NOTIFICATION_ID,
  [ENTITY_NOTIFICATION]: ENTITY_NOTIFICATION_ID,
  [BULK_UPDATE_NOTIFICATION]: BULK_UPDATE_NOTIFICATION_ID,
  [MENTIONS_NOTIFICATION]: MENTIONS_NOTIFICATION_ID,
  [OTHER_NOTIFICATION]: OTHER_NOTIFICATION_ID,
  [TICKET_NOTIFICATION]: TICKET_NOTIFICATION_ID,
};

export const NOTIFICATION_CATEGORY_ID_TO_EVENT_MAP = {
  [TASK_NOTIFICATION_ID]: TASK_NOTIFICATION,
  [PLAYBOOK_NOTIFICATION_ID]: PLAYBOOK_NOTIFICATION,
  [EMAIL_NOTIFICATION_ID]: EMAIL_NOTIFICATION,
  [ENTITY_NOTIFICATION_ID]: ENTITY_NOTIFICATION,
  [BULK_UPDATE_NOTIFICATION_ID]: BULK_UPDATE_NOTIFICATION,
  [MENTIONS_NOTIFICATION_ID]: MENTIONS_NOTIFICATION,
  [OTHER_NOTIFICATION_ID]: OTHER_NOTIFICATION,
  [TICKET_NOTIFICATION_ID]: TICKET_NOTIFICATION,
};

export const ENTITY_NOTIFICATION_MESSAGES = {
  1: {
    currentUser: 'You have been added as the primary owner',
    assignedUser: ' has been added as the primary owner',
  },
  2: {
    currentUser: 'You have been added as an owner',
    assignedUser: ' has been added as an owner',
  },
  3: {
    currentUser: 'You have been removed from the ownership',
    assignedUser: ' has been removed from the ownership',
  },
  4: {
    currentUser: 'You have been added as the ',
    assignedUser: ' was added as the ',
  },
};

export const MENTION_CATEGORY_NOTIFICATION_TYPES = {
  TASK: 1,
  NOTE: 2,
  SUCCESS_PLAN: 3,
  MILESTONE: 4,
  PLAYBOOK: 5,
  ACTIVITY: 6,
  COMMENT: 7,
  FILE_UPLOAD: 8,
  TICKET: 9,
};

export const MENTION_TYPE_ID_MAP = {
  1: 'Task',
  2: 'Note',
  3: 'Success Plan',
  4: 'Milestone',
  5: 'Playbook',
  6: 'Activity',
  7: 'Comment',
  8: 'File',
  9: 'Ticket',
};

export const OTHER_NOTIFICATION_SOURCE_TYPES = {
  ACTION_ITEM_SUCCESS: 1,
  ENTITY_EXPORT: 2,
  ACTION_ITEM_FAILURE: 3,
};
